import QuestionLayout from './QuestionLayout';
export {QuestionLayoutType} from './QuestionLayout.types';

export default QuestionLayout;
